const styles = {
  root: {
    cursor: 'pointer',
    textDecoration: 'none',
  },
  image: {
    position: 'relative',
    width: 220,
    height: 150,
    '& img': {
      borderRadius: 2,
    },
  },

  title: {
    '&.MuiTypography-body1': {
      fontWeight: 600,
    },
  },

  layoutContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
}
export default styles
